import styled from 'styled-components';

export const IndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const Indicator = styled.div<{ isEnabled?: boolean }>`
  width: 12px;
  height: 12px;
  border: 1.5px solid #9299f7;
  border-radius: 50%;
  background: ${({ isEnabled }) => (isEnabled ? '#9299F7' : 'transparent')};
`;
